"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[564],{

/***/ 8564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HowToPlayModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7997);
/* harmony import */ var _components_modals_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5453);


function HowToPlayModal(param) {
    let { setHowToPlayModal , showHowToPlayModal  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_modals_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        onClose: ()=>setHowToPlayModal(false),
        show: showHowToPlayModal,
        modalId: "modal-root",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
            className: "flex h-full flex-col justify-between",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                    className: "flex justify-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                            className: "m-3 flex-1 pl-7",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("h2", {
                                className: "text-center font-semibold text-gray-600 dark:text-gray-400",
                                children: "HOW TO PLAY ANIMERDLE"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                            className: "flex justify-self-end",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                                "aria-label": "Close how to play modal",
                                onClick: ()=>{
                                    setHowToPlayModal(false);
                                },
                                className: "text-custom-mg border-none",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
                                    className: "h-6 w-6",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "gray",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("line", {
                                            x1: "18",
                                            y1: "6",
                                            x2: "6",
                                            y2: "18"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("line", {
                                            x1: "6",
                                            y1: "6",
                                            x2: "18",
                                            y2: "18"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                    className: "flex h-full w-full flex-col justify-between p-2 xl:p-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                            className: "flex gap-5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "gray",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    className: "h-14 w-14 xl:h-7 xl:w-7",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("circle", {
                                            cx: "5.5",
                                            cy: "17.5",
                                            r: "2.5"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("circle", {
                                            cx: "17.5",
                                            cy: "15.5",
                                            r: "2.5"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                                            d: "M8 17V5l12-2v12"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                    children: "Listen to the audio clip and try to guess which Anime it is from"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                            className: "flex gap-5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "gray",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    className: "h-14 w-14 xl:h-8 xl:w-8",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                                        d: "M13 17l5-5-5-5M6 17l5-5-5-5"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                    children: "Skipping or incorrect attempts will unlock larger portions of the audio"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                            className: "flex gap-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "gray",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    className: "h-11 w-11 xl:h-6 xl:w-5",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
                                        d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("span", {
                                    children: [
                                        "Answer with the fewest number of attempts possible and guess today's",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("strong", {
                                            children: "Animerdle"
                                        }),
                                        "!"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                            "aria-label": "Play the game",
                            onClick: ()=>setHowToPlayModal(false),
                            className: "w-25 mx-auto rounded bg-primary-600 p-12 py-2 text-white duration-200 ease-in-out hover:bg-primary-700 hover:opacity-80 dark:bg-primary-700",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                className: "text-sm font-semibold",
                                children: "I'm ready"
                            })
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 5453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1720);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _TransparentBackground__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6220);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 400px;\n  padding: 15px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}





const Modal = (param)=>{
    let { show , onClose , children , modalId  } = param;
    const [isBrowser, setIsBrowser] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setIsBrowser(true);
    }, []);
    const handleCloseClick = (e)=>{
        e.preventDefault();
        onClose();
    };
    const modalContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_TransparentBackground__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                onClick: handleCloseClick,
                show: show
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(StyledModal, {
                className: "absolute top-0 w-[21rem] translate-x-[calc(50vw_-_10.5rem)] border bg-gray-100 duration-300 ease-in-out dark:border-gray-700 dark:bg-gray-900 sm:translate-x-[calc(50vw_-_10.5rem)] lg:w-1/3 lg:translate-x-[calc(50vw_-_100vw*1/6)] xl:w-1/4 xl:translate-x-[calc(50vw_-_100vw*1/8)] ".concat(show ? "translate-y-[calc(20vh)] opacity-100" : "-translate-y-full opacity-0"),
                children: children
            })
        ]
    });
    if (isBrowser) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__["default"].createPortal(modalContent, document.getElementById(modalId));
    } else {
        return null;
    }
};
const StyledModal = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Modal);


/***/ })

}]);